/**
 * Full page reload, kept behind a function so tests can observe it
 * (jsdom's `location.reload` cannot be spied on reliably).
 */
export const reloadPage = (): void => {
  globalThis.location.reload();
};
